import { Link } from "react-router-dom";
import BigPanel from "../../components/BigPanel/BigPanel";
import { useConsent } from "../../hooks/useConsent";
import "../../components/CookieBanner/CookieBanner.css";

function CookieSettings() {
  const { consent, saveConsent, acceptAll, rejectAll } = useConsent();

  return (
    <BigPanel title="Cookie-Einstellungen">
      <h2>1. Worum geht es?</h2>
      <p>
        Wir verwenden notwendige Cookies für Grundfunktionen. Statistik- und Marketing-Technologien
        setzen wir nur nach deiner Einwilligung ein. Details findest du in unserer{" "}
        <Link to="/datenschutz">Datenschutzerklärung</Link>.
      </p>

      <h2>2. Kategorien</h2>

      <div className="cookie-settings is-open" style={{ maxHeight: "none", opacity: 1, paddingTop: 0 }}>
        {/* Notwendig */}
        <div className="cookie-settings-row">
          <div className="cookie-settings-label">
            <span className="cookie-settings-title">Notwendig</span>
            <span className="cookie-settings-sub">Für Grundfunktionen (immer aktiv)</span>
          </div>
          <div className="cookie-toggle is-on is-locked" aria-hidden="true">
            <span className="cookie-toggle-dot" />
          </div>
        </div>

        {/* Statistik */}
        <div className="cookie-settings-row">
          <div className="cookie-settings-label">
            <span className="cookie-settings-title">Statistik</span>
            <span className="cookie-settings-sub">Auswertung zur Optimierung</span>
          </div>
          <button
            type="button"
            className={"cookie-toggle" + (consent.analytics ? " is-on" : "")}
            onClick={() =>
              saveConsent({
                analytics: !consent.analytics,
                marketing: consent.marketing,
              })
            }
            aria-pressed={consent.analytics}
          >
            <span className="cookie-toggle-dot" />
          </button>
        </div>

        {/* Marketing */}
        <div className="cookie-settings-row">
          <div className="cookie-settings-label">
            <span className="cookie-settings-title">Marketing</span>
            <span className="cookie-settings-sub">Google Ads Conversion-Tracking</span>
          </div>
          <button
            type="button"
            className={"cookie-toggle" + (consent.marketing ? " is-on" : "")}
            onClick={() =>
              saveConsent({
                analytics: consent.analytics,
                marketing: !consent.marketing,
              })
            }
            aria-pressed={consent.marketing}
          >
            <span className="cookie-toggle-dot" />
          </button>
        </div>

        <div className="cookie-settings-save">
          <button className="btn cookie-btn" type="button" onClick={acceptAll}>
            Alle akzeptieren
          </button>
          <button className="cookie-link" type="button" onClick={rejectAll}>
            Alles ablehnen
          </button>
        </div>
      </div>

      <h2>3. Widerruf & Rechtsgrundlagen</h2>
      <p>
        Du kannst deine Einwilligung jederzeit mit Wirkung für die Zukunft ändern oder widerrufen.
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO sowie § 25 Abs. 1 TTDSG.
      </p>
    </BigPanel>
  );
}

export default CookieSettings;
